// A different credential per target prevents one approved host from impersonating
// this browser to another host. Passwords are never stored.
export function guestIdentity(code: string): string {
  const storageKey = 'rc_guest_identity_v1_' + code;
  try {
    const saved = localStorage.getItem(storageKey);
    if (saved && /^[a-f0-9]{64}$/.test(saved)) return saved;
  } catch { /* Private browsing can still authorize this one session. */ }
  const key = Array.from(crypto.getRandomValues(new Uint8Array(32)), b => b.toString(16).padStart(2, '0')).join('');
  try { localStorage.setItem(storageKey, key); } catch { /* No persistent trust in this browser. */ }
  return key;
}
